import { OVER_UNDER } from '../constants';
import {
	type BettingSplitsBet,
	type BettingSplitsDrawBet,
	type BettingSplitsTeamBet,
	type MarketClassification,
} from '../types';

export function sortBetsBySequence<M extends MarketClassification>(
	bets: BettingSplitsBet[],
	marketClassification: M,
	marketGenericSequence: M extends Omit<MarketClassification, typeof OVER_UNDER>
		? string
		: never,
) {
	switch (marketClassification) {
		case OVER_UNDER: {
			const sequence = OVER_UNDER.split('_');
			bets.sort(
				(a, b) =>
					sequence.indexOf(a.betName.toUpperCase()) -
					sequence.indexOf(b.betName.toUpperCase()),
			);

			return bets;
		}
		default: {
			const sequence = marketGenericSequence
				.split('_')
				.map(i => i.toLowerCase());
			const drawBet = bets.filter(
				(bet): bet is BettingSplitsDrawBet => !bet.teamType,
			);
			const teamBets = bets.filter(
				(bet): bet is BettingSplitsTeamBet => !!bet.teamType,
			);

			teamBets.sort(
				(a, b) => sequence.indexOf(a.teamType) - sequence.indexOf(b.teamType),
			);

			const middleIndex = Math.floor(teamBets.length / 2);
			const sortedBets = [...teamBets] as BettingSplitsBet[];
			sortedBets.splice(middleIndex, 0, ...drawBet);

			return teamBets;
		}
	}
}
